/**
 * HUD 绘制：顶栏分数/倍率/擦弹、右上 boss 状态、底部残机/炸弹/火力/特殊槽、左下关名。
 * 全部用文字/色块，monospace 字体。仅在浏览器运行时调用。
 */
import { VIEW_H } from '../config.js';
import { POWER_MAX, SPECIAL_MAX } from './state.js';
import { diffName, L } from '../i18n.js';

/**
 * 绘制一帧 HUD。
 * @param {import('../engine/renderer.js').Renderer} renderer
 * @param {import('./state.js').GameState} state
 */
export function drawHud(renderer, state) {
  const s = state.scoring;
  const score = String(Math.floor(s.score)).padStart(9, '0');
  const hiscore = String(Math.floor(Math.max(state.hiscore || 0, s.score))).padStart(9, '0');

  // 顶栏：分数 / HISCORE / 倍率 / 擦弹
  renderer.text(`SCORE  ${score}`, 8, 6, { size: 12, color: '#fff' });
  renderer.text(`HISCORE ${hiscore}`, 8, 20, { size: 10, color: '#fa4' });
  renderer.text(`x${s.multiplier.toFixed(1)}`, 220, 6, { size: 12, color: s.multiplier >= 4.99 ? '#ff4' : '#8f8' }); // 满值=pointMax/pointBase=5.0（9.9 是 v1 残留阈值）
  renderer.text(`GRAZE ${s.graze}`, 220, 20, { size: 10, color: '#8cf' });

  // 底部：残机图标 / 炸弹图标 / 火力条 / 特殊槽
  const by = VIEW_H - 18;
  const shownLives = Math.min(state.lives, 5); // 图标区到炸弹区最多 5 个，超出 ×n（无上限溢出历史 bug）
  for (let i = 0; i < shownLives; i++) {
    renderer.circle(14 + i * 14, by + 4, 5, { fill: '#cdf', stroke: '#fff' });
  }
  if (state.lives > 5) renderer.text(`×${state.lives}`, 18 + 4 * 14, by - 1, { size: 10, color: '#cdf' });
  for (let i = 0; i < state.bombs; i++) {
    renderer.rect(90 + i * 12, by, 9, 9, { fill: '#3c3', stroke: '#fff' });
  }
  // 火力条
  renderer.text('POWER', 200, by, { size: 9, color: '#ccc' });
  renderer.rect(240, by, 100, 8, { fill: '#311', stroke: '#655' });
  renderer.rect(240, by, 100 * (state.power / POWER_MAX), 8, {
    fill: state.power >= POWER_MAX ? '#ff4' : '#f66',
  });
  renderer.text(`${state.power}/${POWER_MAX}`, 344, by, { size: 9, color: '#ccc' });
  // 特殊槽（满时高亮）
  const full = state.special >= SPECIAL_MAX;
  renderer.rect(400, by, 72, 8, { fill: '#113', stroke: full ? '#ff4' : '#557' });
  renderer.rect(400, by, 72 * (state.special / SPECIAL_MAX), 8, { fill: full ? '#ff4' : '#48f' });
  if (full) renderer.text('SPECIAL READY', 400, by - 12, { size: 9, color: '#ff4' });

  // 左下：当前关名 + 难度（关名/难度名按语言）
  const stageName = L(state.stageName || `STAGE ${state.stageIndex + 1}`);
  const diffLabel = state.difficulty ? ` · ${diffName(state.difficulty)}` : '';
  renderer.text(stageName + diffLabel, 8, VIEW_H - 32, { size: 10, color: '#aac' });
}
